(()=>{
const root=document.querySelector('.rv[data-page="reviews"]');
if(!root)return;
const $=selector=>root.querySelector(selector);
const rawLang=document.documentElement.lang||'en';
let strings={};
try{strings=JSON.parse($('#rv-strings').textContent)||{};}catch(error){strings={};}
const t=(key,vars)=>{let text=strings[key]||'';for(const name in (vars||{}))text=text.replace('{'+name+'}',vars[name]);return text;};

/* Video reviews: product filter chips, show-more, and YouTube that loads only on click. */
const section=$('[data-rv-videos]');
if(section){
 const cards=Array.from(section.querySelectorAll('[data-rv-card]'));
 const chips=Array.from(section.querySelectorAll('.rv-chip'));
 const filterBar=$('[data-rv-filter]'),more=$('#rv-more'),status=$('#rv-status');
 const mq=window.matchMedia('(max-width:767px)');
 let current='all',expanded=false;
 const limit=()=>mq.matches?3:6;
 function apply(announce){
  const matching=cards.filter(card=>current==='all'||card.dataset.product===current);
  const cap=current==='all'&&!expanded?limit():matching.length;
  cards.forEach(card=>{const index=matching.indexOf(card);card.hidden=index<0||index>=cap;});
  if(more)more.hidden=!(current==='all'&&!expanded&&matching.length>cap);
  if(announce&&status){
   const active=chips.find(chip=>chip.dataset.filter===current);
   status.textContent=current==='all'?t('status_all'):t('status_filter',{filter:active?active.textContent.trim():''});
  }
 }
 chips.forEach(chip=>chip.addEventListener('click',()=>{
  current=chip.dataset.filter;
  chips.forEach(other=>other.setAttribute('aria-pressed',String(other===chip)));
  apply(true);
 }));
 if(more)more.addEventListener('click',()=>{expanded=true;apply(false);const first=cards.filter(card=>!card.hidden)[limit()];if(first){const poster=first.querySelector('[data-rv-play]');if(poster)poster.focus({preventScroll:true});}});
 if(mq.addEventListener)mq.addEventListener('change',()=>apply(false));
 if(filterBar){
  filterBar.hidden=false;
  const strip=filterBar.querySelector('.rv-chips');
  const edge=()=>{if(strip)filterBar.toggleAttribute('data-end',strip.scrollLeft+strip.clientWidth>=strip.scrollWidth-4);};
  if(strip){strip.addEventListener('scroll',edge,{passive:true});edge();}
 }
 apply(false);
 section.addEventListener('click',event=>{
  const button=event.target.closest('[data-rv-play]');
  if(!button)return;
  const card=button.closest('[data-rv-card]');
  const media=button.closest('.rv-card-media');
  if(!card||!media)return;
  const frame=document.createElement('iframe');
  const start=Number(card.dataset.start)||0;
  frame.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(card.dataset.videoId)+'?autoplay=1&rel=0&playsinline=1'+(start?'&start='+start:'');
  frame.title=card.dataset.title||'';
  frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
  frame.allowFullscreen=true;
  media.textContent='';
  media.appendChild(frame);
  frame.focus();
 });
}

/* Owner wall guard: if Loox never mounts its widget, collapse the empty section instead of leaving a blank stretch. The timer starts when the
   wall first comes near the viewport (Loox mounts then) and gives it 8 seconds. */
const wallSection=$('#rv-wall');
if(wallSection&&'IntersectionObserver' in window){
 const wallObserver=new IntersectionObserver(entries=>{
  if(!entries.some(entry=>entry.isIntersecting))return;
  wallObserver.disconnect();
  setTimeout(()=>{const widget=wallSection.querySelector('#looxReviews');if(!widget||!widget.children.length){wallSection.hidden=true;const navWall=root.querySelector('a[href="#rv-wall"]');if(navWall)navWall.hidden=true;}},8000);
 },{rootMargin:'600px 0px'});
 wallObserver.observe(wallSection);
}

/* Mobile sticky action: shown only while the hero, package, demo and close band are off screen. */
const sticky=$('.rv-mobile-action');
const visible=new Map();
if(sticky&&'IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{
  entries.forEach(entry=>visible.set(entry.target,entry.isIntersecting));
  sticky.hidden=[...visible.values()].some(Boolean);
 },{threshold:.05});
 [$('.rv-hero'),$('#rv-setup'),$('#rv-demo'),$('.rv-close')].forEach(el=>{if(el)observer.observe(el);});
}

/* Live price, saving and Premium Care value from the store's own product JSON. */
const routeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||root.dataset.root||'';
const abort=new AbortController();
const timer=setTimeout(()=>abort.abort(),8000);
function fetchProduct(handle){
 if(!routeRoot)return Promise.reject(new Error('No market root'));
 return fetch(routeRoot+'products/'+handle+'.js',{signal:abort.signal}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.json();});
}
Promise.all(root.hasAttribute('data-no-product')?[Promise.reject(new Error('No product in this market'))]:[
 fetchProduct('speediance-gym-monster-3'),
 fetchProduct('speediance-premium-care-2-year-in-home-service-plan').catch(()=>null)
]).then(([product,premiumCare])=>{
 const studioId=root.dataset.studioVariant;
 const variant=(product.variants||[]).find(v=>v.available&&Number(v.price)>0&&((studioId&&String(v.id)===studioId)||(!studioId&&v.sku==='GM3STUDIO')));
 if(!variant)return;
 const currency=product.currency||(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active);
 if(!currency)return;
 const money=amount=>new Intl.NumberFormat(rawLang,{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:0}).format(amount/100);
 const vat=Number(root.dataset.vat)||0;
 const withVat=cents=>vat?Math.ceil(cents*(1000+vat)/100000)*100:cents;
 const price=withVat(Number(variant.price)),compareAt=Number(variant.compare_at_price||0)?withVat(Number(variant.compare_at_price)):0;
 const hasSaving=compareAt>price;
 const save=hasSaving?compareAt-price:0;
 const priceText=money(price);
 const productUrl=location.origin+routeRoot+'products/speediance-gym-monster-3?variant='+encodeURIComponent(variant.id);
 const priceEl=$('#rv-price');priceEl.textContent=priceText;priceEl.href=productUrl;
 if(hasSaving){
  $('#rv-price-compare-value').textContent=money(compareAt);$('#rv-price-compare').hidden=false;
  const saveEl=$('#rv-price-save');saveEl.textContent=t('save',{save:money(save)});saveEl.hidden=false;
 }
 const ctaText=hasSaving?t('cta_save',{save:money(save)}):t('cta');
 const heroCta=$('#rv-hero-cta');
 if(heroCta){heroCta.textContent=ctaText;heroCta.href=productUrl;}
 const closeCta=$('#rv-close-cta');
 if(closeCta){
  const full=closeCta.querySelector('.rv-cta-full'),short=closeCta.querySelector('.rv-cta-short');
  if(full)full.textContent=ctaText;
  if(short)short.textContent=hasSaving?t('cta_save_short',{save:money(save)}):t('cta_short');
  closeCta.href=productUrl;
 }
 const productLink=$('#rv-product-link');
 if(productLink){productLink.innerHTML=(hasSaving?t('product_link_save',{price:priceText}):t('product_link'))+' <span aria-hidden="true">→</span>';productLink.href=productUrl;}
 const stickyCta=$('#rv-sticky-cta');
 if(stickyCta){stickyCta.innerHTML=(hasSaving?t('sticky_save',{save:money(save)}):t('sticky'))+' <span aria-hidden="true">→</span>';stickyCta.href=productUrl;}
 root.querySelectorAll('.rv-product-copy .rv-link').forEach(link=>{link.href=productUrl;});
 if(variant.featured_image&&variant.featured_image.src){const productImg=$('#rv-product-image');if(productImg)productImg.src=variant.featured_image.src;}
 const careVariant=premiumCare&&Array.isArray(premiumCare.variants)?premiumCare.variants[0]:null;
 const careValue=careVariant&&Number(careVariant.price)>0?money(withVat(Number(careVariant.price))):null;
 const careEl=$('#rv-care-value');
 if(careEl&&careValue)careEl.textContent=t('care_value',{value:careValue});
}).catch(()=>{}).finally(()=>clearTimeout(timer));

/* Rating: the average is rendered by Liquid from the summary Loox renders inside the wall block (data-rating on the root, already in the store's
   decimal style). Nothing is typed in copy and no review count is ever shown. */
const shown=root.dataset.rating;
function showRating(text){
 root.querySelectorAll('[data-rv-rating]').forEach(el=>{el.textContent=text;});
 const ratingEl=$('#rv-rating'),textEl=$('#rv-rating-text');
 if(ratingEl&&textEl){textEl.textContent=t('rating',{rating:text});ratingEl.hidden=false;}
}
if(shown&&Number(shown.replace(',','.'))>0)showRating(shown);
})();
